import React from 'react';
import styles from './TableListEditableNew.module.scss';

const ExternalLinkFormatter = ({ value, urlFormatter, className }: {
  value: string;
  urlFormatter: (value: string) => string;
  className?: string;
}) => (
  <div className={styles.ExternalLinkCell}>
    <a href={urlFormatter(value)} className={className} target="_blank" rel="noreferrer">{value}</a>
  </div>
);

export default ExternalLinkFormatter;
